import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import SpinnerTw from '~/components/SpinnerTw';

// Standardized approach to Suspense component and fallback
export default function SuspendedArea({
  children,
  fallback = <SpinnerTw center={true} />, // pass null for "no fallback"
}: {
  children: React.ReactNode
  fallback?: React.ReactNode
}) {
  return (
    <Suspense fallback={fallback}>
      {children}
    </Suspense>
  );
}; 